// extracted by mini-css-extract-plugin
export default {"technology":"technology_technology__v0aZ8","img":"technology_img__kw9Hm"};